import React from 'react';
import {
    ArrowDownIcon,
    ArrowUpIcon,
    Bars2Icon,
    ChevronDoubleDownIcon,
    ChevronDoubleUpIcon,
} from '@heroicons/react/24/outline';
import Tooltip from '../tooltip';

const PRIORITY_MAP = {
    Highest: {Icon: ChevronDoubleUpIcon, colorClass: 'text-red-600'},
    High:    {Icon: ArrowUpIcon,          colorClass: 'text-orange-500'},
    Medium:  {Icon: Bars2Icon,            colorClass: 'text-amber-700'},
    Low:     {Icon: ArrowDownIcon,        colorClass: 'text-blue-600'},
    Lowest:  {Icon: ChevronDoubleDownIcon,colorClass: 'text-sky-400'},
};

const PRIORITY_ID_TO_NAME = {5: 'Highest', 4: 'High', 3: 'Medium', 2: 'Low', 1: 'Lowest'};

const TaskPriorityIcon = ({taskPriority, taskPriorityID}) => {
    const name = taskPriority ?? PRIORITY_ID_TO_NAME[+taskPriorityID];
    const config = PRIORITY_MAP[name];

    if (!config) return null;

    const {Icon, colorClass} = config;

    return (
        <Tooltip content={name}>
            <span className={`inline-flex items-center gap-1.5 ${colorClass}`}>
                <Icon className="w-4 h-4 shrink-0" strokeWidth={2.5} />

                <span>{name}</span>
            </span>
        </Tooltip>
    );
};

export default TaskPriorityIcon;
